/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';
import {HosBaseService} from './hos-base.service';

import {Observable} from 'rxjs';
import {PageTrackPerformancesWrapper} from '../model/pageTrackPerformancesWrapper';
import {TrackPerformancesWrapper} from '../model/trackPerformancesWrapper';
import {PageAppStoreNotificationShortWrapper} from '../model/pageAppStoreNotificationShortWrapper';
import {AppStoreNotificationWrapper} from '../model/appStoreNotificationWrapper';


@Injectable()
export class AppStoreNotificationsService extends HosBaseService {

    constructor(injector: Injector) {
        super(injector);
    }

  /**
   * View App Store notifications
   *
   * @param startDate The start date for filtering (optional)
   * @param endDate The end date for filtering (optional)
   * @param page Results page you want to retrieve (0..N)
   * @param customerId Filter by customer ID (optional)
   * @param originalTransactionId Filter by original transaction ID (optional)
   * @param customerEmail Filter by customer email (optional)
   * @param size Number of records per page.
   * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAppStoreNotifications(startDate?: Date, endDate?: Date, customerId?: number, originalTransactionId?: string, customerEmail?: string, page?: number, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<PageAppStoreNotificationShortWrapper>;
  public getAppStoreNotifications(startDate?: Date, endDate?: Date, customerId?: number, originalTransactionId?: string, customerEmail?: string, page?: number, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageAppStoreNotificationShortWrapper>>;
  public getAppStoreNotifications(startDate?: Date, endDate?: Date, customerId?: number, originalTransactionId?: string, customerEmail?: string, page?: number, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageAppStoreNotificationShortWrapper>>;
  public getAppStoreNotifications(startDate?: Date, endDate?: Date, customerId?: number, originalTransactionId?: string, customerEmail?: string, page?: number, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

    if (startDate != null) {
      queryParameters = queryParameters.set('startDate', startDate.toISOString());
    }
    if (endDate != null) {
      queryParameters = queryParameters.set('endDate', endDate.toISOString());
    }
    if (customerId != null) {
      queryParameters = queryParameters.set('customerId', customerId.toString());
    }
    if (originalTransactionId != null) {
      queryParameters = queryParameters.set('originalTransactionId', originalTransactionId);
    }
    if (customerEmail != null) {
      queryParameters = queryParameters.set('customerEmail', customerEmail);
    }
    if (page != null) {
      queryParameters = queryParameters.set('page', page.toString());
    }
    if (size != null) {
      queryParameters = queryParameters.set('size', size.toString());
    }
    if (sort) {
      sort.forEach((element) => {
        queryParameters = queryParameters.append('sort', element);
      });
    }

    let headers = this.getDefaultHeaders();

    // Optional Accept header
    const httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined = undefined;
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = [];

    return this.httpClient.get<PageAppStoreNotificationShortWrapper>(
      `${this.getBasePath()}/api/webtools/v1/app-store-notifications`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Return Notification Details by the Id
   *
   * @param notificationId The notification Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAppStoreNotificationsDetails(notificationId: number, observe?: 'body', reportProgress?: boolean): Observable<AppStoreNotificationWrapper>;
  public getAppStoreNotificationsDetails(notificationId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AppStoreNotificationWrapper>>;
  public getAppStoreNotificationsDetails(notificationId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AppStoreNotificationWrapper>>;
  public getAppStoreNotificationsDetails(notificationId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    if (notificationId === null || notificationId === undefined) {
      throw new Error('Required parameter notificationId was null or undefined when calling getGiftDetails.');
    }

    let headers = this.getDefaultHeaders();

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.get<AppStoreNotificationWrapper>(`${this.getBasePath()}/api/webtools/v1/app-store-notifications/${encodeURIComponent(String(notificationId))}`,
      {
        // withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}
